import React from 'react';

import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";

import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import FormToggle from "root/ReactHookForm/ui/FormToggle";
import {FormSectionNames} from "root/s360components/LearningJournal/LearningJournalPage";

export const parentFields = () =>
{
    return {
        [FormSectionNames.FILTERS]:
            {
                parent_obs: false,
                show_coel: true,
            }
    }
}

const HookSubFormParentSelector = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    return (
        <S360WidgetBlock title='Options'>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <div className='form-toggle-container'>
                        <div className='form-toggle-toggle'>
                            <FormToggle readOnly={false} control={control} name={sectionName+ '.show_coel'}/>
                        </div>
                        <div className='toggle-label'>Show CoEL / ALDs in journal?</div>
                    </div>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <div className='form-toggle-container'>
                        <div className='form-toggle-toggle'>
                            <FormToggle readOnly={false} control={control} name={sectionName+ '.parent_obs'}/>
                        </div>
                        <div className='toggle-label'>Include parent observations?</div>
                    </div>
                </BootstrapCol>
            </BootstrapRow>
        </S360WidgetBlock>
    )
}


export default HookSubFormParentSelector;
